import { Component, OnInit, ViewChild, Inject } from '@angular/core';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { BehaviorSubject } from 'rxjs';
import { tap, first } from 'rxjs/operators';
import { indicate } from 'src/app/operators';
import { EsraPipingAPIClient, PressureTemperatureTableViewModel } from 'src/app/shared/models/autogenerated-piping';
import { faSearch } from '@fortawesome/free-solid-svg-icons';
import { MatSort, Sort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { PressureTempPreviewComponent } from 'src/app/admintool/piping/dictionaries/dialogs/pressure-temp-preview/pressure-temp-preview.component';

export interface PressureTempTableModalData {
  existingTables?: PressureTemperatureTableViewModel[];
}

@Component({
    selector: 'app-add-pressure-temp-table',
    templateUrl: './add-pressure-temp-table.component.html',
    styleUrl: './add-pressure-temp-table.component.scss',
    standalone: false
})
export class AddPressureTempTableComponent implements OnInit {
  dataSource = new MatTableDataSource();
  sortColumn: string = '';
  sortDirection: string = '';
  searchText = '';
  columnNames: string[] = ['NAME', 'PREVIEW'];

  protected selectedItem: PressureTemperatureTableViewModel[] = [];

  faSearch = faSearch;
  currentPage = 0;
  pageSize = 25;
  totalCount: number;
  pageSizes = [2, 5, 10, 25, 50, 100];

  searching$ = new BehaviorSubject<boolean>(false);

  @ViewChild('paginator') paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;


  constructor(
    private esraApiClient: EsraPipingAPIClient,
    private dialog: MatDialog,
    public dialogRef: MatDialogRef<AddPressureTempTableComponent>,
    @Inject(MAT_DIALOG_DATA) public data?: PressureTempTableModalData
  ) {
    // Initialize selectedItem with existing tables if provided
    if (data?.existingTables && data.existingTables.length > 0) {
      this.selectedItem = [...data.existingTables];
    }
  }

  ngOnInit(): void {
    this.sortDirection = 'asc';
    this.updateSearchResults(this.sortDirection, this.searchText);
  }

  public updatePage(event: PageEvent) {
    this.pageSize = event.pageSize;
    this.currentPage = event.pageIndex;
    this.updateSearchResults(this.sortDirection, this.searchText);
  }

  callSearch(e) {
    if (e.keyCode == 13) {
      this.currentPage = 0;
      this.paginator.firstPage();
      this.search();
    }
  }

  public search() {
    this.updateSearchResults(
      this.sortDirection,
      this.searchText
    );
    this.updateSearchResults(
      this.sortDirection,
      this.searchText
    );
  }

  private updateSearchResults(sortDirection: string, searchPhrase: string) {
    this.esraApiClient.getPaginatedPressureTemperatureTables(
      Number(this.currentPage),
      Number(this.pageSize),
      sortDirection,
      searchPhrase,
      true // Show active only by default
    )
    .pipe(
      indicate(this.searching$),
      first(),
      tap(searchResult => {
        this.totalCount = searchResult.totalResults;
        this.dataSource.data = searchResult.results;
        this.dataSource.sort = this.sort;
      })
    ).subscribe();
  }

  public previewTable(tableVM: PressureTemperatureTableViewModel[]) {
    this.dialog.open(PressureTempPreviewComponent, {
        minWidth: '60vw',
        minHeight: '50vh',
        maxWidth: '90vw',
        maxHeight: '90vh',
        data: tableVM
      });
  }

  protected sortData(sort: Sort) {
    this.sortDirection = sort.direction;
    this.updateSearchResults(this.sortDirection, this.searchText);
  }

  checkboxChanged(addItem: boolean, item) : void {
    if (addItem) {
      const existingIndex = this.selectedItem.findIndex(component => component.id === item.id);

      if (existingIndex >= 0) {
        this.selectedItem[existingIndex] = item;
      } else {
        this.selectedItem.push(item);
      }
    } else {
      this.selectedItem = this.selectedItem.filter(component => component.id !== item.id);
    }
  }

  isChecked(item) : boolean  {
    const isSelected = this.selectedItem.some(component => component.id === item.id);
    if (this.selectedItem.length > 0 && !this.hasLoggedCheck) {
      this.hasLoggedCheck = true;
    }
    return isSelected;
  }

  private hasLoggedCheck = false;

  cancel(): void {
    this.dialogRef.close();
  }

  save(){
    this.dialogRef.close(this.selectedItem);
  }
}
